export default __webpack_public_path__ + "static/media/app-promo-nl.b290cbdc.png";